import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_CARRIER_RESPONSIBLE_EMAIL_" }
);

export interface PaginateCarrierResponsibleEmailState extends IState {
  data: Record<string, any>[];
}

const INITIAL_STATE: PaginateCarrierResponsibleEmailState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateCarrierResponsibleEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: PaginateCarrierResponsibleEmailState,
  action: ISuccessAction
) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (
  state: PaginateCarrierResponsibleEmailState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateCarrierResponsibleEmail = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateCarrierResponsibleEmailTypes = Types;
export const PaginateCarrierResponsibleEmailActions = Creators;
